module.exports = __webpack_public_path__ + "media/application/images/9001-6231c13a2718afe8d90cc8a7e72385fa.jpg";